import React, { useEffect, useState, memo } from "react";
import Chart from "react-apexcharts";
import { api } from "../api/api";
import { ApexOptions } from "apexcharts";

interface ChartSeries {
  name: string;
  data: number[];
}

// Memoized to prevent re-rendering when parent components update
const SentEmailsChart: React.FC = memo(() => {
  const [dates, setDates] = useState<string[]>([]);
  const [regular, setRegular] = useState<number[]>([]);
  const [reminders, setReminders] = useState<number[]>([]);
  const [softLanding, setSoftLanding] = useState<number[]>([]);
  const [insuranceCard, setInsuranceCard] = useState<number[]>([]);
  const [courierMatch, setCourierMatch] = useState<number[]>([]);
  const [anniversaryCount, setAnniversaryCount] = useState<number[]>([]);
  const [telegramRegistration, setTelegramRegistration] = useState<number[]>([]);
  const [secretSantaRegistration, setSecretSantaRegistration] = useState<number[]>([]);
  const [secretSantaParticipants, setSecretSantaParticipants] = useState<number[]>([]);
  const [secretSantaPresent, setSecretSantaPresent] = useState<number[]>([]);

  useEffect(() => {
    api.history.sentLettersChart()
      .then((data) => {
        setDates(data.dates.map((d) => d + ' 12:00'));
        setRegular(data.regularPackagesCount);
        setReminders(data.remindersCount);
        setSoftLanding(data.softLandingPackagesCount);
        setInsuranceCard(data.insuranceCardPackagesCount);
        setCourierMatch(data.courierMatchCount);
        setAnniversaryCount(data.anniversaryCount);
        setTelegramRegistration(data.telegramRegistrationCount);
        setSecretSantaRegistration(data.secretSantaRegistrationPackagesCount);
        setSecretSantaParticipants(data.secretSantaParticipantsPackagesCount);
        setSecretSantaPresent(data.secretSantaPresentPackagesCount);
      });
  }, []);

  const chartOptions: ApexOptions = {
    chart: {
      id: "basic-bar",
      type: 'line',
      toolbar: {
        show: true
      },
      zoom: {
        enabled: true
      }
    },
    theme: {
      palette: 'palette8'
    },
    xaxis: {
      type: 'datetime',
      categories: dates
    },
    legend: {
      position: 'right',
      offsetY: 30
    },
  };

  const series: ChartSeries[] = [
    {
      name: "Regular packages",
      data: regular
    },
    {
      name: "Reminders",
      data: reminders
    },
    {
      name: "Courier Match",
      data: courierMatch
    },
    {
      name: "Anniversary notifications",
      data: anniversaryCount
    },
    {
      name: "Soft landing packages",
      data: softLanding
    },
    {
      name: "Cigna cards",
      data: insuranceCard
    },
    {
      name: "Telegram registrations",
      data: telegramRegistration
    },
    {
      name: "Secret Santa registration",
      data: secretSantaRegistration
    },
    {
      name: "Secret Santa participant",
      data: secretSantaParticipants
    },
    {
      name: "Secret Santa presents",
      data: secretSantaPresent
    }
  ];

  return (
    <>
      <Chart
        options={chartOptions}
        series={series}
        type="line"
        height={500}
      />
    </>
  );
});

SentEmailsChart.displayName = "SentEmailsChart";

export default SentEmailsChart;
